import { render } from "./AppPost.vue?vue&type=template&id=637153e0"
import script from "./AppPost.vue?vue&type=script&lang=js"
export * from "./AppPost.vue?vue&type=script&lang=js"

import "./AppPost.vue?vue&type=style&index=0&id=637153e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__